import axios from 'axios';
import {
    authHeader
} from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;


class StatistikService {
    getTotalUserDepartement() {
        return axios.get(API_URL + 'user/total-user-departement', {
            headers: authHeader()
        });
    }
    getTotalUser() {
        return axios.get(API_URL + 'user/total-user', {
            headers: authHeader()
        });
    }
    getTotalUserOnline() {
        return axios.get(API_URL + 'user/total-user-online', {
            headers: authHeader()
        });
    }
    getTotalUserActive() {
        return axios.get(API_URL + 'user/total-active-user', {
            headers: authHeader()
        });
    }
    getTotalAdmin() {
        return axios.get(API_URL + 'profile/total-admin', {
            headers: authHeader()
        });
    }
    getTotalAdminActive() {
        return axios.get(API_URL + 'profile/total-admin-active', {
            headers: authHeader()
        });
    }
    getTotalGroup() {
        return axios.get(API_URL + 'group/total-group', {
            headers: authHeader()
        });
    }
    getTotalMembersGroup() {
        return axios.get(API_URL + 'total-members', {
            headers: authHeader()
        });
    }
    getWeekly() {
        return axios.get(API_URL + 'weekly', {
            headers: authHeader()
        });
    }
    getTotalMessage() {
        return axios.get(API_URL + 'total-message', {
            headers: authHeader()
        });
    }
    getTotalMessageUser() {
        return axios.get(API_URL + 'total-message-user', {
            headers: authHeader()
        });
    }
    getTotalMessageGroup() {
        return axios.get(API_URL + 'total-message-group', {
            headers: authHeader()
        });
    }
    getTopLogins() {
        return axios.get(API_URL + 'user/top-login', {
            headers: authHeader()
        });
    }
    getTopMessages() {
        return axios.get(API_URL + 'user/top-send-message', {
            headers: authHeader()
        });
    }
    getTopCallings() {
        return axios.get(API_URL + 'user/top-calling', {
            headers: authHeader()
        });
    }

    getTopBandwidth() {
        return axios.get(API_URL + 'statistic/total-bandwidth', {
            headers: authHeader()
        });
    }

    getTotalBandwidth() {
        return axios.get(API_URL + 'statistic/bandwidth', {
            headers: authHeader()
        });
    }

    getTopInteractionsCall(params) {
        return axios.get(API_URL + 'statistic/interactions-call', {
            params: params,
            headers: authHeader()
        });
    }

    getTopInteractionsMessage(params) {
        return axios.get(API_URL + 'statistic/interactions-msg', {
            params: params,
            headers: authHeader()
        });
    }

    getTopInteractionsCallGroup(params) {
        return axios.get(API_URL + 'statistic/interactions-group-calls', {
            params: params,
            headers: authHeader()
        });
    }

    getTopInteractionsMessageGroup(params) {
        return axios.get(API_URL + 'statistic/interactions-group-msg', {
            params: params,
            headers: authHeader()
        });
    }
}

export default new StatistikService();